// Auto-extracted from LangContext.jsx — single source of truth for FR translations.
// Edit this file to update wording. Keys must stay in sync across active locales (see ACTIVE_LANGS).
/* eslint-disable */
const dict = {
  app_tagline: "L'avenir des playbooks de basketball",
  nav_dashboard: 'Tableau', nav_playbook: 'Playbook', nav_editor: 'Éditeur', nav_roster: 'Effectif',
  nav_ai: 'Coach IA', nav_live: 'Match en direct', nav_simulator: 'Simulateur', nav_academy: 'Académie',
  nav_invitations: 'Invitations', nav_admin: 'Admin', nav_pricing: 'Tarifs',
  nav_manual: 'Manuel',
  nav_marketplace: 'Marketplace', nav_profile: 'Mon Profil', nav_notifications: 'Notifications', nav_achievements: 'Trophées',
  nav_tactile: 'Tactile', mob_market: 'Marché', mob_ia: 'IA',
  login: 'Connexion', register: 'Inscription', logout: 'Déconnexion', email: 'Email', password: 'Mot de passe',
  name: 'Nom', role: 'Rôle', coach: 'Coach', player: 'Joueur', or: 'ou',
  welcome_back: 'Bon retour', create_account: 'Créer un compte',
  invite_share_text: "Salut {name}, nous t'invitons à rejoindre l'équipe « {team} » sur PlayMaster IA. Inscris-toi ici : {url}",
  invite_share_text_generic: "Nous t'invitons à rejoindre l'équipe « {team} » sur PlayMaster IA. Inscris-toi ici : {url}",
  invite_share_text_no_team: "Je t'invite à rejoindre mon équipe sur PlayMaster IA. Inscris-toi ici : {url}",
  invite_share_title: 'Invitation · {name}',
  invite_share_native_text: "Salut {name}, nous t'invitons à rejoindre l'équipe « {team} » sur PlayMaster IA.",
  register_invite_coach_team: "Le coach {coach} vous invite à rejoindre l'équipe {team}.",
  register_invite_coach_no_team: 'Le coach {coach} vous invite à créer votre compte.',
  register_show_password: 'Afficher le mot de passe', register_hide_password: 'Masquer le mot de passe',
  register_your_username: 'Votre identifiant',
  register_save_credentials: "Conserve cet identifiant et ton mot de passe pour te reconnecter. On t'amène à ton playbook...",
  register_terms_intro: "En vous inscrivant, vous acceptez nos",
  register_terms_link: 'Conditions',
  register_terms_and: 'et notre',
  register_privacy_link: 'Politique de Confidentialité',
  register_google_locale: 'fr',
  plays: 'Jeux', total_plays: 'Total des jeux', active_players: 'Joueurs actifs',
  success_rate: 'Taux de réussite', ai_sessions: 'Sessions IA',
  search: 'Rechercher...', all_categories: 'Toutes catégories',
  cat_man: 'vs H-à-H', cat_zone: 'vs Zone', cat_ato: 'ATO', cat_blob: 'BLOB', cat_slob: 'SLOB', cat_endgame: 'Fin de match',
  create_play: 'Créer un jeu', save: 'Enregistrer', cancel: 'Annuler', edit: 'Modifier', delete: 'Supprimer',
  upload_photo: 'Photo', add_player: 'Ajouter',
  height: 'Taille', weight: 'Poids', number: 'Numéro', position: 'Poste',
  dominant_hand: 'Main dominante', strength: 'Force', weakness: 'Faiblesse', ideal_role: 'Rôle idéal',
  generate_link: "Générer lien d'invitation", copy_link: 'Copier', copied: 'Copié',
  chat_placeholder: "Posez une question à l'IA...",
  send: 'Envoyer', generate_play: 'Générer un jeu', recommend_plays: 'Recommander',
  predict_success: 'Prédire',
  defense: 'Défense', moment: 'Moment', recommend: 'Recommander',
  step: 'Étape', steps: 'étapes', play: 'Lire', stop: 'Arrêter',
  pause: 'Pause', prev: 'Préc.', next: 'Suiv.', loop_label: 'Boucle', off_label: 'Off',
  worked: '✔ A marché', didnt_work: '✕ Raté',
  coach_premium: 'Coach Premium', player_premium: 'Player Premium', academy: 'Académie',
  month: 'mois', subscribe: "S'abonner",
  hello: 'Salut', loading: 'Chargement...', view_all: 'Voir tout', back: 'Retour', close: 'Fermer', confirm: 'Confirmer',
  language: 'Langue', settings: 'Réglages', not_found: 'Introuvable',
  top_plays: 'Top jeux par taux de réussite', distribution: 'Répartition', open_ai_coach: 'Ouvrir Coach IA',
  my_roster: 'Mon effectif', my_publications: 'Mes Annonces', no_plays_yet: "Vous n'avez pas encore créé de jeux",
  no_invitations_yet: "Aucune invitation générée pour l'instant", go_to: 'Aller à', go_to_editor: "Allez à l'Éditeur",
  dashboard_subtitle: 'Tableau de contrôle de votre équipe', greeting_morning: 'Bonjour',
  privacy_policy: 'Politique de confidentialité', terms_of_service: "Conditions d'utilisation",
  error_generic: 'Erreur', invalid_credentials: 'Identifiants invalides',
  have_account: 'Déjà un compte ?', no_account: "Pas encore de compte ?",
  invites_subtitle: 'Liens courts avec votre domaine et statistiques de clics / inscriptions.',
  invite_label: 'Libellé', invite_label_placeholder: 'Équipe principale',
  invite_custom_slug: 'Slug personnalisé (optionnel)',
  voice: 'Voix', muted: 'Muet',
  voice_on_hint: 'Narration activée (cliquer pour couper)',
  voice_off_hint: 'Activer la narration vocale',
  loop_on_hint: 'Lecture en boucle',
  loop_off_hint: 'Boucle désactivée',
  translating: 'Traduction...',
  show_as: 'Afficher comme:', photo: 'Photo', initials: 'Initiales',
  description_label: 'Description', works_against: 'Fonctionne contre',
  listen_narration: 'Écouter la narration', tactical_simulator: 'Simulateur Tactique',
  ai_prediction: 'Prédiction IA', export_share: 'Exporter & partager',
  image_label: 'Image', share_whatsapp_btn: 'Partager via WhatsApp', generating_dots: 'Génération…',
  delete_confirm: 'Supprimer ce jeu ?', deleted: 'Supprimé',
  pdf_generated: 'PDF généré', image_downloaded: 'Image téléchargée',
  frames_not_ready: 'Frames pas prêts, réessayez',
  share_error: 'Erreur de partage', image_export_error: "Erreur d'export image",
  pdf_export_error: "Erreur d'export PDF", prediction_error: 'Erreur de prédiction IA',
  feedback_success_yes: 'Marqué comme réussi', feedback_success_no: 'Marqué comme raté',
  feedback_error: 'Erreur feedback', translation_error: 'Erreur de traduction',
  cached_translation: 'Traduction en cache', translated_by_ai: 'Traduit par IA',
  translated_to: 'Traduit en', translate_with_ai: 'Traduire avec IA',
  whatsapp_open_attach: "WhatsApp ouvert : joignez l'image téléchargée",
  reviews_title: 'Avis', your_review: 'Votre avis', publish_review: 'Publier',
  update_review: 'Mettre à jour',
  review_placeholder: 'Optionnel : dites aux autres coachs ce que vous en pensez...',
  only_buyers_review: 'Seuls les coachs ayant acheté peuvent évaluer.',
  no_reviews_yet: "Pas encore d'avis. Soyez le premier.",
  choose_star: 'Choisissez au moins 1 étoile', review_sent: 'Avis envoyé',
  must_buy_review: 'Vous devez acheter ce jeu pour le commenter',
  review_singular: 'avis', review_plural: 'avis',
  editor_title: 'Play Creator Pro',
  editor_subtitle: 'Compatible avec stylet tactile, doigt et souris. Sélectionnez « Crayon libre » pour dessiner.',
  blank_board: 'Tableau vierge', templates: 'Modèles', preview_label: 'Aperçu',
  play_name: 'Nom', play_description: 'Description',
  category: 'Catégorie', difficulty: 'Difficulté',
  beginner: 'Débutant', intermediate: 'Intermédiaire', advanced: 'Avancé',
  pencil_free: 'Crayon libre',
  add_offense: '+Attaque', add_defense: '+Défense',
  steps_title: 'Étapes', add_step: 'Ajouter', step_description: "Description de l'étape",
  speed: 'Vitesse', delay_exit: '⏱ Délai au départ',
  assign_player_circle: 'Assigner un joueur au cercle',
  quick_player_selection: 'Sélection rapide de joueurs',
  animation_preview: "Aperçu avec animation",
  load_template_title: 'Charger un modèle',
  export_pdf_title: 'Exporter en PDF',
  export_png_title: 'Télécharger en image',
  share_whatsapp_title: 'Partager via WhatsApp',
  clear_text: 'Effacer', unassigned: 'Non assigné',
  double_click_assign: "Double-clic sur un cercle pour ouvrir ce sélecteur. Photo + numéro + nom seront affichés.",
  route_timing: 'Timing des trajectoires',
  route_timing_desc: 'Vitesse et délai de chaque joueur pour chorégraphier pick&roll, back-door, double écran…',
  my_roster_quick: 'Mon effectif — tap rapide',
  players_count: 'joueurs',
  no_roster_yet_label: 'Aucun joueur. Ajoutez dans',
  no_roster_yet_label_after: 'pour une sélection rapide.',
  quick_add_hint: 'Tap sur un joueur, il apparaît instantanément. Double-tap sur un cercle pour réassigner.',
  on_court_badge: 'EN JEU', tips_label: 'Astuces',
  tip_offense_defense_a: "tap sur le terrain pour ajouter un cercle générique.",
  tip_pencil_a: 'dessinez la',
  tip_pencil_b: 'trajectoire du joueur',
  tip_pencil_c: "à partir de son cercle et le système ajoutera l'étape suivante. Les courbes libres restent comme annotation.",
  tip_double_tap: "Double-tap sur n'importe quel cercle pour le réassigner à un joueur de l'effectif.",
  no_name: 'Sans nom', my_new_play: 'Mon nouveau jeu', step_default_desc: 'Étape',
  move_players: 'Déplacer joueurs', arrow_move: 'Flèche mouvement',
  pass_tool: 'Passe', dribble_tool: 'Dribble', screen_tool: 'Écran', eraser_tool: 'Gommer',
  saved_ok: 'Enregistré', save_error_msg: "Erreur d'enregistrement",
  ai_hero_title: 'Bonjour, je suis ton Coach IA',
  ai_hero_subtitle: 'Demande-moi des jeux, optimisations, prédictions ou stratégies.',
  ai_powered_by: 'Propulsé par PlayMaster IA',
  ai_quick_1_label: 'Créer un jeu contre zone 2-3',
  ai_quick_2_label: 'Recommander des ATO vs homme',
  ai_quick_3_label: 'Optimiser Horns Flare',
  ai_quick_1_prompt: 'Conçois un nouveau jeu pour attaquer une défense en zone 2-3. Explique les 3 étapes clés et pourquoi ça marche.',
  ai_quick_2_prompt: 'Recommande les 3 meilleurs jeux ATO (after time-out) contre défense homme-à-homme. Justifie.',
  ai_quick_3_prompt: "J'ai le jeu Horns Flare. Comment optimiser le spacing et les angles d'écran pour le rendre plus létal contre les switches ?",
  ai_connection_error: 'Erreur de connexion IA',
  academy_title: 'Académie',
  academy_subtitle: "Concepts tactiques, lecture de jeu et fondamentaux. Tapez sur une leçon pour voir des tutoriels YouTube curés.",
  academy_will_open_youtube: 'Nous ouvrirons YouTube avec des tutoriels curés sur ce sujet.',
  academy_watch_youtube: 'Voir les tutoriels sur YouTube',
  academy_coming_soon: 'Bientôt : leçons natives enregistrées par des coachs élites.',
  academy_lesson_1_title: 'Spacing : comment ouvrir le terrain',
  academy_lesson_2_title: 'Comment attaquer la zone 2-3',
  academy_lesson_3_title: 'Défendre le Pick & Roll : drop coverage vs switch',
  academy_lesson_4_title: 'Lecture de jeu : quand changer de rythme',
  academy_lesson_5_title: 'Exécution de la Horns Action',
  academy_lesson_6_title: 'BLOB et SLOB dans les moments clés',
  academy_cat_fundamentals: 'Fondamentaux',
  academy_cat_vs_zone: 'Vs Zone',
  academy_cat_defense: 'Défense',
  academy_cat_iq: 'QI',
  academy_cat_systems: 'Systèmes',
  academy_cat_ato_blob: 'ATO/BLOB',
  pricing_h1: 'Élevez votre jeu', pricing_subtitle: 'Choisissez le plan adapté à votre coaching.',
  plan_most_popular: 'Le plus populaire', payments_mocked: 'MOCKED · Les paiements seront intégrés à Stripe dans la prochaine version.',
  payments_secure: 'Paiements sécurisés par Stripe.',
  pay_current_plan: 'Plan actuel', pay_active: 'Actif', pay_expires_on: 'Expire le',
  pay_redirecting: 'Redirection…', pay_cancelled: 'Paiement annulé. Réessayez quand vous voulez.',
  pay_no_session: 'Session de paiement introuvable.',
  pay_verifying: 'Vérification du paiement…', pay_verifying_sub: 'Cela ne prendra que quelques secondes.',
  pay_thanks_tag: 'MERCI', pay_success_title: 'Abonnement activé !',
  pay_success_plan: 'Plan', pay_go_dashboard: 'Aller au tableau de bord',
  pay_expired_title: 'Session expirée', pay_expired_sub: 'La session de paiement a expiré. Réessayez pour continuer.',
  pay_timeout_title: 'Vérification en attente', pay_timeout_sub: 'Nous confirmons avec Stripe. Vérifiez votre email — votre plan sera activé une fois confirmé.',
  pay_error_title: 'Erreur de paiement', pay_back_pricing: 'Retour aux plans',
  stop_edit: "Retour à l'édition",
  nav_teams: 'Équipes', teams_h1: 'Mes équipes',
  teams_subtitle: "Gérez une ou plusieurs équipes. Chaque équipe a son propre roster et s'applique partout dans l'éditeur, le playbook et la communication.",
  teams_empty: "Vous n'avez pas encore d'équipe. Créez la première ci-dessus.",
  team_create: 'Créer une équipe', team_create_first: 'Créer une équipe',
  team_name: "Nom de l'équipe", team_name_placeholder: 'Ex: Loups U18',
  team_category: 'Catégorie', team_cat_male: 'Masculin', team_cat_female: 'Féminin', team_cat_mixed: 'Mixte',
  team_created: 'Équipe créée', team_updated: 'Équipe mise à jour', team_deleted: 'Équipe supprimée',
  team_delete_confirm: "Supprimer l'équipe « {name} » ? Les joueurs seront déplacés vers l'équipe suivante disponible.",
  team_active: 'Actif', team_already_active: 'Équipe active', team_set_active: 'Activer',
  team_none: 'Aucune équipe', team_manage: 'Gérer les équipes',
  team_using: 'Équipe active',
  roster_status_filter: 'Filtre',
  roster_status_active: 'Actifs', roster_status_blocked: 'Bloqués',
  roster_status_archived: 'Archivés', roster_status_all: 'Tous',
  roster_archive_confirm: 'Archiver ce joueur ? Il sera masqué mais réactivable à tout moment.',
  roster_player_archived: 'Joueur archivé',
  roster_player_reactivated: 'Joueur réactivé',
  roster_archive_title: 'Archiver', roster_reactivate: 'Réactiver',
  nav_assignments: 'Tâches', assignments_h1: 'Tâches hebdomadaires',
  assignments_empty: 'Aucune tâche assignée à cette équipe pour le moment.',
  assign_create: 'Créer une tâche', assign_edit: 'Modifier la tâche',
  assign_title: 'Titre', assign_title_placeholder: 'Ex : Révision de la semaine',
  assign_due: "Échéance", assign_notes: 'Notes (optionnel)',
  assign_notes_placeholder: 'Instructions pour les joueurs',
  assign_select_plays: 'Sélectionnez les jeux', assign_no_plays: 'Aucun jeu disponible',
  assign_created: 'Tâche créée', assign_updated: 'Tâche mise à jour', assign_deleted: 'Tâche supprimée',
  assign_delete_confirm: 'Supprimer cette tâche ?', assign_overdue: 'EN RETARD', plays: 'jeux',
  invite_team: 'Équipe', invite_team_none: "Aucune équipe assignée",
  feat_playbook_full: 'Playbook complet (100 jeux)',
  feat_advanced_editor: 'Éditeur avancé',
  feat_unlimited_roster: 'Effectif illimité',
  feat_50_ai: '50 sessions IA/mois',
  feat_unlimited_invites: 'Invitations illimitées',
  feat_global_plays: 'Accès aux jeux globaux',
  feat_didactic_photos: 'Vue didactique avec vos photos',
  feat_personal_ai_coach: 'Coach IA personnel',
  feat_individual_stats: 'Statistiques individuelles',
  feat_academy_mode: 'Mode académie',
  feat_100_players: "Jusqu'à 100 joueurs",
  feat_multi_coach: 'Multi-coach',
  feat_unlimited_ai: 'IA illimitée',
  feat_personal_branding: 'Marque personnalisée',
  feat_priority_support: 'Support prioritaire',
  live_h1: 'Mode Match en Direct',
  live_subtitle: "Sélectionnez la défense adverse et le moment ; l'IA recommande 3 jeux.",
  live_voice_on: 'Voix activée — Mode Match', live_voice_off: 'Activer la narration vocale',
  live_voice_extra: 'Chaque jeu sera lu à voix haute étape par étape.',
  live_defense_label: 'Défense :', live_moment_label: 'Moment :',
  live_justification: 'Justification IA', live_see_detail: 'Voir détail',
  def_man: 'vs H-à-H', def_zone_2_3: 'vs Zone 2-3', def_zone_3_2: 'vs Zone 3-2',
  def_zone_1_3_1: 'vs Zone 1-3-1', def_switch: 'vs Switch', def_press: 'vs Press',
  moment_half_court: 'Demi-terrain', moment_ato: 'After Time-out (ATO)',
  moment_blob: 'BLOB (Ligne de fond)', moment_slob: 'SLOB (Touche)', moment_endgame: 'Fin de match',
  marketplace_seller_blurb: 'vous gardez 85 % de chaque vente. Prix : 0,99 $ – 99,99 $.',
  profile_eyebrow: 'Profil', profile_h1: 'Mon Profil de Coach',
  profile_player_h1: 'Mon Profil de Joueur',
  profile_player_subtitle: "Votre coach voit ces mêmes informations dans l'effectif.",
  profile_player_photo_help: "Votre photo s'affichera sur le tableau de jeu quand votre coach vous assignera à une action.",
  elite_verified_badge: 'Coach Élite Vérifié', identity_section: 'Identité',
  no_photo: 'PAS DE PHOTO', upload_photo_btn: 'Téléverser une photo',
  photo_help: "Votre photo et vos références sont la première chose que verront les acheteurs. Soyez professionnel.",
  field_display_name: 'Nom public', field_team: 'Équipe', field_country: 'Pays',
  field_credentials: 'Références (ex. Head Coach · 10 ans · Ligue ACB)',
  field_twitter: 'Twitter / X (@pseudo)', field_instagram: 'Instagram (@pseudo)',
  field_website: 'Site web', field_bio: 'Bio (dites à la communauté quel coach vous êtes)',
  save_profile_btn: 'Enregistrer le profil', elite_status: 'Statut Élite',
  verified_state: 'VÉRIFIÉ',
  elite_active_text: 'Votre compte est élite. Vos jeux sont visibles dans le Marketplace.',
  elite_since: 'Depuis :', view_my_store: 'Voir ma boutique',
  not_elite_yet: "Vous n'êtes pas encore Coach Élite. Demandez la vérification pour vendre des jeux dans le Marketplace.",
  requirements_label: 'Prérequis :',
  req_bio_photo: 'Bio + photo professionnelle', req_credentials: 'Références vérifiables',
  req_5_plays: 'Min. 5 jeux personnels créés',
  request_verification: 'Demander la vérification (admin seul en v1)',
  my_achievements: 'Mes Trophées', no_achievements: "Vous n'avez encore débloqué aucun trophée.",
  publish_in_marketplace: 'Publier sur le Marketplace',
  unpublish_from_marketplace: 'Retirer du Marketplace',
  photo_uploaded: 'Photo téléversée', upload_error: 'Erreur de téléversement',
  profile_saved: 'Profil enregistré', play_published: 'Jeu publié sur le marketplace',
  play_unpublished: 'Retiré du marketplace',
  price_prompt: 'Prix (USD, entre 0,99 et 99,99)',
  sale_blurb_prompt: 'Description de vente courte :', purchased_badge: '(Achetée)',
  landing_get_started: 'Commencer', landing_install_app: "Installer l'app",
  landing_hero_subtitle: 'Le premier playbook intelligent conçu pour les entraîneurs de basket. Concevez, simulez et partagez des jeux avec IA.',
  landing_feature_editor: 'Éditeur visuel', landing_feature_editor_desc: 'Dessinez des jeux tactiles au doigt ou au stylet. Animations automatiques.',
  landing_feature_ai: 'Coach IA', landing_feature_ai_desc: "Générez des jeux, recommandez contre toute défense, prédisez le succès.",
  landing_feature_share: 'Partage facile', landing_feature_share_desc: 'Exportez en PDF, partagez via WhatsApp avec de vraies animations.',
  landing_install_short: 'Installer',
  landing_hero_h1_a: "L'avenir des", landing_hero_h1_b: 'Playbooks de Basket',
  landing_hero_h2: 'Le playbook de basketball #1 avec IA pour coachs et joueurs',
  landing_hero_para: "PlayMaster IA redéfinit l'avenir des playbooks de basketball avec l'écosystème de coaching propulsé par IA le plus avancé. Créez, enseignez et exécutez des jeux de basketball d'élite grâce à un éditeur visuel avec photos réelles, une bibliothèque croissante de jeux professionnels, IA générative et prédictive, gestion d'effectif, invitations et un système complet de développement pour équipes et académies.",
  landing_hero_para_2: "Conçu pour le basketball jeunesse, lycée, AAU, académies et coaching professionnel, PlayMaster IA combine technologie moderne et stratégie réelle de basketball pour aider coachs et joueurs à penser plus vite, jouer plus intelligemment et gagner davantage.",
  landing_stat_plays: 'Jeux', landing_stat_languages: 'Langues', landing_stat_coach_24: 'Coach 24/7',
  landing_live_preview: 'Aperçu live',
  landing_cap_eyebrow: 'Capacités',
  landing_cap_h1_a: 'Un écosystème complet', landing_cap_h1_b: "pour le basket d'élite",
  landing_f_playbook_t: 'Global Playbook', landing_f_playbook_d: "Plus de 117 jeux professionnels — et en croissance — classés par Man, Zone, ATO, BLOB, SLOB et End-of-Game, tous avec animations pas-à-pas et structure didactique.",
  landing_f_ai_t: 'AI Coach', landing_f_ai_d: "L'IA génère de nouvelles actions, optimise les existantes et prédit la probabilité de succès. Elle recommande aussi en direct pendant les matchs.",
  landing_f_roster_t: 'Roster with Photos', landing_f_roster_d: "Téléversez de vraies photos et créez des profils complets de joueurs. Glissez vos joueurs directement sur le terrain pour des actions 100% didactiques et personnalisées.",
  landing_f_langs_t: '3 Languages', landing_f_langs_d: "Disponible en espagnol, anglais et français, avec narration IA, auto-traduction et enrichissement didactique.",
  landing_f_live_t: 'Live Game Mode', landing_f_live_d: "Sélectionnez la défense adverse et le moment du match ; l'IA recommande 3 actions instantanées avec explication tactique.",
  landing_f_editor_t: 'Visual Editor', landing_f_editor_d: "Terrain style NBA, outils flottants, dessin de mouvements, écrans, coupes et actions multi-étapes. L'éditeur le plus intuitif et puissant du basketball moderne.",
  landing_cta_h1: 'Prêt à révolutionner votre tableau ?', landing_cta_demo: 'Coach démo :',
  landing_cta_btn: 'Commencer gratuitement', contact: 'Contact',
  achievements_eyebrow: 'Trophées', achievements_h1: 'Mes Trophées',
  achievements_subtitle_a: "Débloquez des badges en utilisant l'app.", achievements_subtitle_b: 'débloqués.',
  achievements_progress: 'Progression', achievements_latest: 'Derniers trophées débloqués',
  achievements_no_data: 'Aucune donnée.', achievements_no_yet: "Commencez à utiliser l'app !",
  cat_creation: 'Création', cat_roster_t: 'Effectif', cat_sales: 'Marketplace (Vendeur)',
  cat_buying: 'Marketplace (Acheteur)', cat_quality: 'Qualité', cat_status: 'Statut', cat_ai: 'IA',
  tier_bronze: 'BRONZE', tier_silver: 'ARGENT', tier_gold: 'OR', tier_elite: 'ÉLITE',
  no_badges_yet: 'Aucun trophée pour le moment.',
  notifications_eyebrow: 'Notifications', notifications_h1: 'Centre de notifications',
  notif_enable_push: 'Activer Push', notif_test: 'Test', notif_disable_push: 'Désactiver push',
  notif_mark_all: 'Tout marquer', notif_empty: 'Aucune notification pour le moment.',
  notif_marked_all: 'Tout marqué comme lu',
  notif_push_on: "Push activé. Nous vous préviendrons même si vous fermez l'app.",
  notif_push_off: 'Push désactivé', notif_push_error: "Impossible d'activer",
  notif_test_sent: 'Push test envoyé', notif_test_error: "Erreur d'envoi du test",
  devices: 'appareil', devices_plural: 'appareils',
  market_h1: "Playbooks d'Élite",
  market_subtitle: 'Achetez des jeux créés par des coachs vérifiés. Chaque achat est une copie personnelle ajoutée à votre playbook.',
  market_publish_my_play: 'Publier mon jeu',
  market_publish_my_play_title: 'Publiez votre jeu sur le marketplace',
  market_banner_title: 'Vous êtes coach ? Partagez et vendez votre système',
  market_banner_body: "Publiez vos jeux avec animation, trajets et vitesses. Fixez votre prix entre 0,99 $ et 99,99 $. Vous gardez 85 % de chaque vente.",
  market_banner_start: 'Commencer →',
  market_tab_listings: 'Jeux en vente',
  market_tab_coaches: "Coachs d'Élite",
  market_tab_leaderboard: 'Classement · Coach du Mois',
  market_sort_popular: 'Populaire',
  market_sort_recent: 'Récents',
  market_sort_price_asc: 'Prix ↑',
  market_sort_price_desc: 'Prix ↓',
  market_cat_all: 'Tous',
  market_empty: 'Aucun jeu en vente dans cette catégorie pour le moment.',
  market_sales: 'ventes',
  market_success: 'réussite',
  market_students: 'élèves',
  market_plays_count: 'jeux',
  market_verified_elite: 'Élite Vérifié',
  roster_h1: 'Effectif',
  roster_player_updated: 'Joueur mis à jour',
  roster_player_added: 'Joueur ajouté',
  roster_save_error: 'Erreur de sauvegarde',
  roster_delete_confirm: "Supprimer le joueur ? (Il sera définitivement retiré de l'équipe.)",
  roster_block_confirm: "Bloquer ce joueur ? Il ne fera plus partie de l'équipe et ne verra plus vos jeux.",
  roster_unblock_confirm: 'Débloquer ce joueur ? Il pourra de nouveau voir vos jeux.',
  roster_player_unblocked: 'Joueur débloqué',
  roster_player_blocked: 'Joueur bloqué',
  roster_action_error: "Échec de l'action",
  roster_no_players: "Vous n'avez aucun joueur. Appuyez sur",
  roster_camera_title: "Prendre une photo avec l'appareil",
  roster_upload_gallery_title: 'Téléverser depuis la galerie',
  roster_camera_btn: 'Caméra',
  roster_upload_btn: 'Téléverser',
  roster_photo_uploaded: 'Photo téléversée',
  roster_photo_upload_error: 'Erreur de téléversement',
  roster_blocked_badge: 'Bloqué',
  roster_block_btn: 'Bloquer',
  roster_unblock_btn: 'Réactiver',
  roster_delete_title: 'Supprimer définitivement',
  roster_block_title: "Bloquer et retirer de l'équipe",
  roster_unblock_title: 'Débloquer',
  roster_no_photo: 'PAS DE PHOTO',
  roster_hand_right: 'Droite',
  roster_hand_left: 'Gauche',
  roster_hand_ambi: 'Ambidextre',
  roster_hand_letter_right: 'D',
  roster_hand_letter_left: 'G',
  roster_hand_letter_ambi: 'A',
  roster_player_in_court: 'est déjà sur le terrain',
  roster_player_added_to_court: 'ajouté',
  admin_h1: 'Panneau Admin',
  admin_tab_overview: 'Tableau de bord',
  admin_tab_users: 'Utilisateurs',
  admin_tab_activity: 'Activité',
  admin_coaches: 'Coachs',
  admin_players: 'Joueurs',
  admin_plays_global: 'Jeux globaux',
  admin_ai_sessions: 'Sessions IA',
  admin_top_plays: 'Top jeux',
  admin_by_category: 'Par catégorie',
  admin_col_name: 'Nom',
  admin_col_email: 'Email',
  admin_col_role: 'Rôle',
  admin_col_created: 'Créé',
  admin_delete_user_confirm: "Supprimer l'utilisateur ?",
  admin_recent_activity: 'Activité récente',
  admin_tab_maintenance: 'Maintenance',
  admin_backfill_title: "Backfill d'enrichissement (toutes les langues actives)",
  admin_backfill_body: "Lancer UNE SEULE FOIS pour enrichir chaque jeu dans toutes les langues actives (ES/EN/FR). Les combinaisons déjà enrichies sont ignorées — relancer est gratuit. Les nouveaux jeux s'enrichissent automatiquement à leur création.",
  admin_active_langs: 'Langues actives',
  offline_no_connection: 'Hors-ligne',
  offline_pending: 'en attente',
  offline_syncing: 'Synchronisation…',
  offline_synced: 'Synchronisé',
  offline_cached_session: 'Session en cache (hors-ligne)',
  offline_play_unavailable: "Ce jeu n'est pas téléchargé. Connectez-vous pour le voir.",
  offline_saved_locally: 'Enregistré localement — synchronisation au retour de la connexion',
  tablet_mode: 'Plein écran',
  tablet_mode_title: 'Plein écran pour tablette — idéal pour montrer le jeu pendant un match ou un temps mort',
  present_mode: 'Agrandir',
  present_mode_title: 'Mode présentation : terrain verrouillé en plein écran — aucun mouvement accidentel du doigt/stylet',
  present_mode_exit: 'Fermer',
  sim_back_to_play: 'Retour au jeu',
  sim_eyebrow: 'Simulateur Tactique',
  sim_subtitle: "L'IA simulera la réaction de la défense et suggérera des ajustements concrets.",
  sim_rival_defense: 'Défense adverse',
  sim_exec_level: "Niveau d'exécution",
  sim_run_now: 'Simuler maintenant',
  sim_running: 'Simulation...',
  sim_ai_prediction: 'Prédiction IA',
  sim_confidence: 'Confiance :',
  sim_def_reaction: 'Comment la défense réagirait',
  sim_failure_points: 'Où ça échouerait',
  sim_adjustments: 'Ajustements recommandés',
  sim_key_player: 'Joueur n°1 :',
  tpl_modal_eyebrow: 'Modèles',
  tpl_modal_title: 'Commencez avec un système éprouvé',
  tpl_modal_subtitle: 'Jeux pré-chargés avec vitesses et délais calibrés. Modifiez à votre goût.',
  tpl_steps_count: 'étapes',
  diff_basic: 'Basique',
  diff_medium: 'Moyen',
  diff_advanced: 'Avancé',
  editor_add_defenders: 'Ajouter défenseurs',
  editor_add_defenders_title: 'Placer 5 défenseurs en formation H-à-H',
  editor_defenders_added: '5 défenseurs ajoutés',
  editor_defenders_already: 'Des défenseurs sont déjà sur le terrain',
  editor_remove_defenders: 'Retirer la défense',
  editor_remove_defenders_title: 'Retirer les 5 défenseurs de cette étape',
  editor_defenders_removed: 'Défense retirée',
  enrich_play: '✨ Enrichir la narration',
  regenerate_enrichment: '✨ Régénérer la narration',
  enriching: 'Enrichissement...',
  enrichment_success: 'Jeu enrichi — la voix et les textes sont plus didactiques',
  enrichment_error: "Erreur d'enrichissement",
  enrichment_hint: "L'IA génère des explications plus longues et didactiques (Quoi + Pourquoi + Indice clé) pour chaque étape. La narration lira le texte enrichi.",
  bulk_enrich_section_title: 'Enrichissement en masse',
  bulk_enrich_section_body: "Enrichissez TOUS vos jeux d'un coup dans la langue actuelle. L'IA génère des narrations didactiques (Quoi + Pourquoi + Indice clé) que vos joueurs entendront. S'exécute en arrière-plan — vous pouvez fermer cette fenêtre, la progression est préservée.",
  bulk_enrich_btn: '🚀 Enrichir tous mes jeux',
  bulk_enrich_running: 'Enrichissement',
  bulk_enrich_hint: 'Génère des narrations enrichies pour tous vos jeux dans la langue actuelle.',
  bulk_enrich_force_label: 'Forcer la régénération (même ceux déjà enrichis)',
  bulk_enrich_in_progress: 'Enrichissement des jeux',
  bulk_enrich_done: 'Enrichissement terminé !',
  bulk_enrich_done_title: 'Terminé',
  bulk_enrich_start_error: "Impossible de démarrer l'enrichissement",
  bulk_enrich_completed: 'Terminés',
  bulk_enrich_skipped: 'Ignorés (déjà enrichis)',
  bulk_enrich_failed: 'Échoués',
  bulk_enrich_current: 'En cours',
  bulk_enrich_errors: 'Erreurs',
  bulk_enrich_background_note: "Cela peut prendre plusieurs minutes selon le nombre de jeux. Vous pouvez fermer cette fenêtre — le processus continue en arrière-plan.",
  /* === Audit fixes — keys présents en ES/EN mais absents en FR === */
  assign_team: 'Équipe', team_choose: "Choisir l'équipe", my_team: 'Mon équipe', demo: 'Démo', view: 'Voir', year: 'an', hello_greeting: 'Bonjour',
  nav_board: 'Tableau', nav_groups: 'Groupes', nav_notes: 'Notes', nav_study: 'Étude', nav_iq_simulator: 'Game IQ Simulator', nav_iq_score: 'IQ Score',
  plan_premium_monthly: 'Premium Mensuel', plan_premium_annual: 'Premium Annuel',
  plan_starter: 'Starter', plan_pro_coach: 'Pro Coach',
  plan_best_value: 'Meilleure offre', plan_starter_addons_hint: 'Add-ons disponibles : IQ Score, Game IQ Simulator, Personal AI Coach',
  feat_everything_starter: 'Tout du Starter',
  feat_everything_unlimited: 'Tout illimité',
  feat_150_ai: '150 sessions IA / mois',
  feat_30_players: "Jusqu'à 30 joueurs",
  feat_includes_iq_score: 'IQ Score inclus',
  feat_includes_iq_full_suite: 'IQ Score + Game IQ Simulator + Personal AI Coach inclus',
  addons_eyebrow: 'À LA CARTE',
  addons_title: 'Add-ons mensuels',
  addons_subtitle: 'Active des fonctionnalités individuelles sans upgrade. Facturées en plus du plan.',
  addon_iq_score_label: 'IQ Score',
  addon_iq_score_desc: "Tableau d'intelligence de jeu avec effectifs et stats sauvegardées.",
  addon_iq_simulator_label: 'Game IQ Simulator',
  addon_iq_simulator_desc: '50+ scénarios réels notés par IA. Défis et classement public.',
  addon_ai_coach_label: 'Personal AI Coach',
  addon_ai_coach_desc: 'Coach IA personnel qui analyse tes jeux et propose des corrections.',
  addon_buy: "Activer l'add-on",
  addon_renew: 'Renouveler',
  addon_included: 'Inclus dans ton plan',
  feat_iq_simulator: 'Game IQ Simulator',
  /* Notes */
  notes_h1: 'Notes privées', notes_subtitle: 'Conversation 1:1 avec vos joueurs.',
  notes_empty_inbox: 'Pas encore de conversations', notes_select_conv: 'Sélectionnez une conversation',
  notes_no_messages: 'Pas encore de messages', notes_message_placeholder: 'Écrire un message…',
  notes_new: 'Nouveau message', notes_pick_player: 'Joueur',
  notes_no_registered_players: "Cette équipe n'a pas encore de joueurs enregistrés. Invitez-les depuis Roster pour pouvoir leur envoyer des notes.",
  notes_all_teams: 'Toutes mes équipes',
  /* Groups */
  groups_h1: 'Groupes', groups_empty: 'Aucun groupe pour le moment',
  group_select: 'Sélectionnez un groupe', group_no_messages: 'Pas encore de messages',
  group_message_placeholder: 'Écrire au groupe…', group_name_placeholder: 'Nom du groupe',
  group_created: 'Groupe créé', group_deleted: 'Groupe supprimé', group_delete_confirm: 'Supprimer ce groupe ?',
  msg_attach_play: 'Joindre une action',
  /* Dashboard */
  dash_inactive_players: 'Joueurs inactifs', dash_inbox: 'Boîte de réception',
  dash_no_study_yet: "Aucune session d'étude pour l'instant",
  dash_study_focus: 'Focus de la semaine', dash_this_week: 'Cette semaine',
  dash_unread: 'Non lus', dash_upcoming_tasks: 'Tâches à venir',
  /* Study */
  study: 'Étude', study_h1: 'Suivi de visionnage', study_empty: 'Pas encore de visionnages',
  study_progress: 'Progrès', study_completed: 'Terminé', study_time: 'Temps',
  study_viewed: 'Visualisé', study_last_seen: 'Vu en dernier', study_player: 'Joueur',
  study_players_count: 'Joueurs', study_team_empty: 'Cette équipe n\'a pas encore de joueurs',
  study_all_teams_subtitle: 'Toutes les équipes',
  /* Player home cards */
  player_my_tasks: 'Mes tâches', player_team_announcements: "Annonces de l'équipe",
  player_unread_notes: 'Messages non lus', player_your_coach: 'Votre entraîneur',
  player_coach_plays: 'Actions du coach', player_coach_plays_title: 'Playbook du coach',
  player_global_sample: 'Bibliothèque globale (extrait)', player_message_coach: 'Envoyer un message au coach',
  play_ask_about: 'Poser une question sur cette action', play_part_of_task: 'Fait partie de la tâche',
  /* Roster invites */
  roster_invite_btn: 'Inviter', roster_invite_copied: 'Lien copié',
  roster_invite_created: 'Invitation créée', roster_invite_title: 'Inviter le joueur',
  roster_send_note: 'Envoyer une note',
  /* IQ Simulator */
  iq_module_label: 'Game IQ Simulator', iq_h1: 'Game IQ Simulator',
  iq_subtitle: 'Entraînez votre QI basketball avec des scénarios réels. Chaque décision est évaluée par un AI coach.',
  iq_total_score: 'Score QI', iq_accuracy: 'Précision', iq_rank: 'Rang', iq_avg_reaction: 'Réaction moy.',
  iq_cat_offensive: 'Offensif', iq_cat_defensive: 'Défensif',
  iq_open_scenario: 'Ouvrir le scénario', iq_what_do_you_do: 'Que faites-vous ?',
  iq_reaction_tracking: 'Temps de réaction en cours…', iq_evaluating: 'Évaluation IA en cours…',
  iq_back_to_hub: 'Retour au simulateur', iq_optimal: 'Décision optimale',
  iq_suboptimal: "Pas la meilleure lecture", iq_optimal_was: 'La décision optimale était',
  iq_tactical_explanation: 'Explication tactique', iq_what_team_should: "Ce que l'équipe doit faire",
  iq_ai_coach: 'AI Coach', iq_try_another: 'Essayer un autre scénario',
  iq_no_scenarios: "Aucun scénario dans cette catégorie pour l'instant.",
  iq_premium_only: "Réservé au plan Premium Annuel",
  iq_premium_pitch: 'Game IQ Simulator est inclus dans le plan Premium Annuel ($249.99/an) avec tous les avantages premium. Le plan mensuel ne comprend pas cette fonction.',
  iq_premium_required: 'Plan Premium Annuel requis.', iq_upgrade_cta: 'Voir les plans',
  /* Phase 2 */
  iq_cat_complete: 'Complet',
  iq_leaderboard: 'Classement',
  iq_tts_on: 'Activer la narration',
  iq_tts_off: 'Couper la narration',
  iq_tts_label_on: 'Narration ON',
  iq_tts_label_off: 'Narration OFF',
  iq_gs_quarter: 'Quart',
  iq_gs_clock: 'Chrono',
  iq_gs_score: 'Score',
  iq_gs_fouls: 'Fautes',
  iq_gs_possession: 'Possession',
  iq_gs_ours: 'Nous',
  iq_gs_theirs: 'Eux',
  iq_gs_bonus: "Tu es en bonus — chaque faute défensive envoie l'adversaire aux LF.",
  iq_lb_all: 'Tous',
  iq_lb_empty: 'Aucune décision enregistrée. Lance un scénario pour entrer dans le classement.',
  iq_lb_player: 'Joueur',
  iq_lb_score: 'IQ',
  iq_lb_attempts: 'Décisions',
  iq_lb_acc: 'Préc.',
  iq_lb_you: 'TOI',
  /* Challenge Mode */
  iqc_module_label: 'Challenge Mode',
  iqc_eyebrow: 'Game IQ Challenge',
  iqc_create_h: 'Créer un défi',
  iqc_create_title_label: 'Titre du défi',
  iqc_create_title_placeholder: 'Ex : Lectures clutch — U17',
  iqc_create_submit: 'Créer le défi',
  iqc_create_success: 'Défi créé !',
  iqc_create_success_sub: "Partage ce lien avec tes joueurs. Quiconque a le lien peut relever le défi.",
  iqc_cta_h: 'Défie tes joueurs',
  iqc_cta_sub: 'Crée un set de 5 scénarios et partage-le par WhatsApp. Le classement du défi se met à jour automatiquement.',
  iqc_cta_btn: 'Créer un défi',
  iqc_my_h: 'Mes défis',
  iqc_attempts: 'tentatives',
  iqc_created_by: 'Créé par',
  iqc_take_challenge: 'Relever le défi',
  iqc_login_to_take: 'Se connecter pour relever',
  iqc_upgrade_to_take: 'Passe en Premium pour relever',
  iqc_how_h: 'Comment ça marche',
  iqc_how_1: '5 scénarios consécutifs — le temps de réaction compte à chaque fois.',
  iqc_how_2: 'Ton score total atterrit dans le classement du défi.',
  iqc_how_3: 'Partage le lien sur WhatsApp et regarde qui bat ton score.',
  iqc_scenario: 'Scénario',
  iqc_total_so_far: 'Total cumulé',
  iqc_complete_eyebrow: 'Défi terminé',
  iqc_complete_h1: 'Tu y es arrivé !',
  iqc_summary_total: 'IQ Total',
  iqc_summary_correct: 'Justes',
  iqc_summary_accuracy: 'Précision',
  iqc_take_again: 'Réessayer',
  iqc_share_my_result: 'Mon score sur ce défi',
  iqc_leaderboard_h: 'Top du défi',
  iqc_max_5: 'Maximum 5 scénarios par défi.',
  iqc_share_default_title: 'Relève mon PlayMaster IA Challenge',
  iqc_share_default_text: "Je t'ai défié sur PlayMaster IA — {title}. Tu acceptes ?",
  iqc_not_found_h1: 'Défi introuvable',
  iqc_not_found_body: 'Le lien a peut-être expiré ou le code est incorrect.',
  back_to_dashboard: 'Retour au Dashboard',
  iq_info_weekly_eyebrow: 'Le top de la semaine',
  iq_info_alltime_eyebrow: 'Les plus joués de tous les temps',
  iq_info_weekly_h: 'Top Challenges',
  iq_info_weekly_sub: "Classement en direct des défis créés par les coaches les plus joués. Touche un code pour le relever — pas besoin de t'inscrire pour prévisualiser.",
  iq_info_weekly_code: 'Code',
  iq_info_weekly_title: 'Défi',
  iq_info_weekly_runs: 'Cette semaine',
  iq_info_weekly_plays: 'Parties',
  /* IQ Score (live in-practice tracker) */
  iqs_eyebrow: "Système officiel d'évaluation",
  iqs_title: 'IQ Score',
  iqs_subtitle: "Tableau de bord vivant pour basket intelligent. Récompense les lectures collectives, pas seulement les paniers. Tape une action chaque fois que ton équipe lit bien le jeu — premier au but gagne.",
  iqs_mode: 'Mode',
  iqs_target: 'Objectif',
  iqs_mode_active: 'Mode',
  iqs_undo: 'Annuler',
  iqs_reset: 'Réinitialiser',
  iqs_team: 'Équipe',
  iqs_team_red: 'Rouge',
  iqs_team_black: 'Noir',
  iqs_impact_plays: 'Jeux à impact',
  iqs_winner: 'Vainqueur',
  iqs_target_reached: 'a atteint',
  iqs_new_game: 'Nouvelle partie',
  iqs_total_actions: 'Actions totales',
  iqs_leader: 'En tête',
  iqs_balance: 'Équilibre du jeu',
  iqs_rules_title: 'Règles et score',
  iqs_rules_basic: "Passe décisive, rebond, contre, interception et écran = 1 pt. Pick & Roll complet : 1.5. Panier sans action préalable : 0.5.",
  iqs_rules_combos: "Les jeux à impact (rebond off. + panier, contre + passe + panier, etc.) valent plus que la somme des actions — ils récompensent les lectures enchaînées.",
  iqs_rules_target: "Choisis l'objectif (12, 20 ou 21) et le mode (2c2 → 5c5). La première équipe à l'atteindre gagne.",
  iqs_rules_purpose: "Conçu pour que coachs et joueurs du banc apprennent en observant. Chaque tap est une lecture.",
  /* IQ Score - actions */
  iqs_a_assist: 'Passe déc.',
  iqs_a_rebound: 'Rebond',
  iqs_a_block: 'Contre',
  iqs_a_steal: 'Interception',
  iqs_a_screen: 'Écran',
  iqs_a_pnr: 'Pick & Roll',
  iqs_a_bucket: 'Panier',
  /* IQ Score - combos */
  iqs_c_oreb_score: 'Rebond off. + panier',
  iqs_c_block_pass_bucket: 'Contre + passe + panier',
  iqs_c_steal_layup: 'Interception + lay-up',
  iqs_c_screen_pass_shot: 'Écran + passe + tir',
  /* IQ Score - roster & save */
  iqs_pick_for: 'Choisir joueur pour',
  iqs_add_player: 'Ajouter joueur',
  iqs_no_roster: "Ton effectif est vide. Va dans Roster pour ajouter des joueurs.",
  iqs_no_players_left: 'Tous les joueurs disponibles sont déjà assignés.',
  iqs_add_selected: 'Ajouter la sélection',
  iqs_selected_count: '{n} sélectionné(s)',
  iqs_no_selection: 'Touche les joueurs pour les sélectionner',
  /* Shot Analyzer */
  nav_shot_analyzer: 'Shot Analyzer',
  addon_shot_analyzer_label: 'Shot Analyzer',
  addon_shot_analyzer_desc: 'Analyse IA de la mécanique de tir avec silhouette fantôme et rapport personnalisé.',
  sa_eyebrow: 'Analyse IA du tir',
  sa_title: 'Shot Analyzer',
  sa_subtitle: 'Enregistre un tir, aligne-toi avec la silhouette fantôme et l\'IA évalue ta mécanique image par image. 100% local.',
  sa_manual_button: 'Manuel',
  sa_manual_eyebrow: 'Avant de commencer',
  sa_manual_title: 'Manuel d\'utilisation',
  sa_manual_intro: 'Pour que l\'analyse soit précise, suis ces consignes à chaque utilisation :',
  sa_manual_accept: 'Compris, j\'accepte',
  sa_manual_requirements_title: 'Exigences minimales',
  sa_manual_requirements_body: 'Mobile ou tablette avec caméra, lumière uniforme, fond dégagé, autorisation caméra. Joueur (et cerceau si analyse de distance) visibles.',
  sa_manual_disclaimer: 'Analyse approximative pour feedback technique. Ce n\'est pas un outil biomécanique certifié.',
  sa_man_camera_title: 'Caméra stable',
  sa_man_camera_body: 'Pose le téléphone sur un trépied ou support stable. Hauteur de la taille, perpendiculaire au joueur.',
  sa_man_distance_title: 'Distance ~3m',
  sa_man_distance_body: 'Le joueur doit tenir entièrement à l\'écran (pieds aux mains). Ajuste jusqu\'à le voir en entier.',
  sa_man_light_title: 'Bon éclairage',
  sa_man_light_body: 'Lumière uniforme, pas de contre-jour. Évite de filmer face aux fenêtres ou sources directes.',
  sa_man_align_title: 'Silhouette fantôme',
  sa_man_align_body: 'Au démarrage tu verras une silhouette dorée. Imite sa posture. À 80%+ ça démarre automatiquement.',
  sa_man_good_title: 'Bon exemple',
  sa_man_good_body: 'Joueur centré, perpendiculaire à la caméra, fond dégagé, lumière uniforme, vêtements contrastés.',
  sa_man_bad_title: 'À éviter',
  sa_man_bad_body: 'Caméra qui tremble, joueur coupé, fond de même couleur que les vêtements, lumière latérale forte.',
  sa_camera_denied: 'Accès caméra refusé. Active-le dans les paramètres du navigateur.',
  sa_not_enough_frames: 'Tir trop court. Réessaie en restant dans le cadre pendant tout le mouvement.',
  sa_save_fail: 'Impossible d\'enregistrer la tentative',
  sa_status_loading_model: 'Chargement du modèle IA...',
  sa_status_idle: 'Prêt à démarrer',
  sa_status_align: 'Aligne-toi avec la silhouette',
  sa_status_align_short: 'Aligne ton corps',
  sa_align_headline: 'Aligne-toi avec la silhouette.',
  sa_align_target: 'Objectif',
  sa_status_capturing: 'Capture du tir',
  sa_status_analyzing: 'Analyse de la mécanique',
  sa_status_done: 'Terminé',
  sa_target_match: 'Objectif',
  sa_start: 'Démarrer l\'analyse',
  sa_upload_video: 'Charger vidéo',
  sa_video_load_fail: 'Impossible d\'ouvrir la vidéo',
  sa_video_pick_shooter: 'Touchez le tireur ou laissez en auto (ballon)',
  sa_video_analyze: 'Analyser le tir',
  sa_status_video_scrub: 'Vidéo · choisir le tireur',
  sa_shooter_locked: 'Tireur sélectionné',
  sa_shooter_ready: 'prêt',
  sa_players_detected: 'joueurs',
  sa_new_attempt: 'Nouvelle tentative',
  sa_model_error: 'Erreur de chargement du modèle',
  sa_overall_score: 'Score global',
  sa_metrics: 'Métriques',
  sa_errors: 'Erreurs détectées',
  sa_ai_report: 'Rapport du coach IA',
  sa_generating_report: 'Génération du rapport...',
  sa_no_report: 'Aucun rapport disponible',
  sa_history: 'Tentatives récentes',
  sa_shot_side: 'Bras de tir',
  sa_side_right: 'Droit',
  sa_side_left: 'Gauche',
  sa_disclaimer: 'Analyse approximative pour feedback technique. Ce n\'est pas un outil biomécanique certifié.',
  sa_gated_title: 'Shot Analyzer est un add-on',
  sa_gated_body: 'Débloque l\'analyse IA de la mécanique de tir pour 6,99 $/mois (inclus dans Premium Annuel).',
  sa_gated_cta: 'Voir les plans',
  sa_m_elbow: 'Angle du coude (release)',
  sa_m_knee: 'Flexion du genou (dip)',
  sa_m_release_h: 'Hauteur du release',
  sa_m_balance: 'Équilibre',
  sa_m_align: 'Alignement des épaules',
  sa_m_rhythm: 'Rythme / fluidité',
  sa_m_leg_drive: 'Utilisation des jambes',
  sa_m_dip_ms: 'Temps dip → release',
  sa_m_follow_ms: 'Follow-through',
  sa_m_release_angle: 'Angle de libération',
  sa_m_apex: 'Hauteur de l\'arc',
  sa_m_arc_quality: 'Qualité de l\'arc',
  sa_m_flight_time: 'Temps de vol',
  sa_m_rim_distance: 'Distance au cercle',
  sa_m_rim_made: 'Touche du cercle',
  sa_rim_yes: 'Oui',
  sa_rim_no: 'Non',
  sa_ball_section: 'Trajectoire du ballon',
  sa_no_ball: 'Ballon non détecté sur cette prise',
  sa_tip_orange: 'Utilise un ballon orange avec un bon éclairage pour aider le tracker.',
  sa_rim_calibrate: 'Calibrer le cercle',
  sa_rim_tap_hint: 'Touche le centre du cercle à l\'écran',
  sa_rim_set: 'Cercle marqué',
  sa_rim_reset: 'Réinitialiser',
  sa_rim_auto: 'Auto',
  sa_rim_auto_hint: 'Détecter le cercle automatiquement par vision par ordinateur',
  sa_rim_auto_ok: 'Cercle détecté',
  sa_rim_auto_fail: 'Impossible de détecter le cercle — touche l\'écran',
  sa_camera_needed: 'Active d\'abord la caméra',
  sa_show_trajectory: 'Voir la trajectoire',
  sa_hide_trajectory: 'Masquer la trajectoire',
  sa_err_open_elbow: 'Coude ouvert',
  sa_err_low_release: 'Release bas',
  sa_err_no_legs: 'Pas de jambes',
  sa_err_lean_forward: 'Chute en avant',
  sa_err_lean_backward: 'Chute en arrière',
  sa_err_broken_rhythm: 'Rythme cassé',
  sa_err_pushed_shot: 'Tir poussé',
  sa_err_lack_of_fluidity: 'Manque de fluidité',
  sa_err_misalignment: 'Mauvais alignement',
  sa_err_flat_arc: 'Arc plat',
  sa_err_rainbow_arc: 'Arc en cloche',
  sa_err_short_arc: 'Arc court',
  sa_download_report: 'Télécharger le rapport PDF',
  sa_exporting: 'Génération du PDF...',
  sa_export_fail: 'Impossible de générer le PDF',
  sa_pdf_title: 'Rapport d\'analyse du tir',
  sa_pdf_player: 'Joueur',
  sa_pdf_attempts_logged: 'Tentatives enregistrées',
  sa_pdf_personal_best: 'Meilleure marque',
  sa_pdf_avg: 'Moyenne',
  sa_pdf_errors_found: 'Erreurs détectées',
  sa_pdf_vs_last: 'vs précédent',
  sa_pdf_no_errors: 'Aucune erreur détectée sur cette prise. Excellente exécution.',
  sa_pdf_progress: 'Progression (10 dernières prises)',
  sa_pdf_progress_caption: 'Score global par tentative. Axe Y : 0–100.',
  sa_pdf_recommendations: 'Recommandations pour progresser',
  sa_rec_elbow: 'Rentre le coude : amène-le à 90° au release et garde-le sous le ballon. Drill : 50 form shots à 1m d\'un mur.',
  sa_rec_release: 'Monte le set point : relâche au-dessus du front, pas de la poitrine. Drill : 3×10 reps devant un miroir, release haut.',
  sa_rec_legs: 'Utilise les jambes : approfondis le dip à ~130° de genou pour transférer l\'énergie. Drill : 4×8 chair shots.',
  sa_rec_balance: 'Reste centré au saut : corps perpendiculaire au sol au release. Drill : tirs statiques avec follow-through tenu 3s.',
  sa_rec_rhythm: 'Travaille la fluidité : un seul mouvement continu dip→release. Drill : 3×10 tirs en comptant "1 (dip), 2 (release)".',
  sa_rec_follow: 'Tiens le follow-through au moins 1s pointé vers le cerceau. Drill : 2×15 form shots, freeze de 2s.',
  sa_rec_align: 'Aligne épaules et hanches face au cerceau avant de monter. Drill : 10 tirs en vérifiant pieds + hanches d\'abord.',
  sa_rec_flat_arc: 'Augmente l\'arc : vise une trajectoire plus haute (45°–52°). Drill : 3×10 tirs en passant la balle au-dessus d\'un obstacle de 2m devant le panier.',
  sa_rec_rainbow_arc: 'Baisse légèrement l\'arc : trop haut réduit la précision. Drill : 3×10 tirs en cherchant un arc propre d\'environ 48°.',
  sa_rec_keep: 'Excellente exécution. Renforce le pattern avec du volume.',
  sa_rec_volume: 'Fais 3×25 tirs depuis le même spot cette semaine pour fixer la mémoire musculaire.',
  sa_rec_record: 'Re-enregistre-toi sous 48h et compare : même angle, même cadrage.',
  nav_feedback: 'Feedback',
  fb_eyebrow: 'Ton avis compte',
  fb_title: 'Envoyer un feedback',
  fb_subtitle: "Dis-nous ce qu'on peut améliorer, ce que tu aimerais voir ou signaler un bug. Chaque message arrive à notre équipe.",
  fb_category: 'Catégorie',
  afb_nav: 'Feedback Inbox',
  afb_eyebrow: 'Triage interne',
  afb_title: 'Feedback Inbox',
  afb_subtitle: 'Examine, étiquette et réponds aux messages des utilisateurs.',
  afb_all: 'Tous', afb_status: 'Statut', afb_category: 'Catégorie',
  afb_status_new: 'Nouveau', afb_status_triaged: 'En revue', afb_status_done: 'Résolu',
  afb_status_changed: 'Statut mis à jour', afb_set_status: 'Définir le statut',
  afb_stat_total: 'Total', afb_stat_new: 'Nouveaux', afb_stat_triaged: 'En revue', afb_stat_done: 'Résolus',
  afb_empty: 'Aucun feedback avec ces filtres.',
  afb_replies: 'Réponses précédentes',
  afb_reply_label: "Répondre à l'utilisateur par email",
  afb_reply_placeholder: "Écris ta réponse. Elle sera envoyée par email à l'utilisateur et notifiée in-app.",
  afb_reply_send: 'Envoyer la réponse', afb_sending: 'Envoi...',
  afb_reply_sent: 'Réponse envoyée à {email}',
  afb_reply_fail: "Impossible d'envoyer la réponse",
  afb_reply_validation: 'Écris au moins 10 caractères.',
  fb_cat_bug: 'Bug', fb_cat_bug_desc: 'Quelque chose ne fonctionne pas correctement',
  fb_cat_idea: 'Idée', fb_cat_idea_desc: 'Une amélioration ou une nouvelle fonctionnalité',
  fb_cat_praise: 'Compliment', fb_cat_praise_desc: 'Quelque chose que tu as adoré',
  fb_cat_other: 'Autre', fb_cat_other_desc: 'Tout autre commentaire',
  fb_field_title: 'Titre',
  fb_title_placeholder: "Ex : « Le bouton de téléchargement ne répond pas sur Safari »",
  fb_field_body: 'Détails',
  fb_body_placeholder: "Raconte-nous en détail ce qui s'est passé, ce que tu attendais, sur quel appareil, etc.",
  fb_field_rating: 'Expérience globale (optionnel)',
  fb_send: 'Envoyer le feedback', fb_sending: 'Envoi...',
  fb_send_fail: "Impossible d'envoyer le feedback",
  fb_validation: 'Remplis le titre (min 3) et les détails (min 10 caractères).',
  fb_success_title: 'Merci ! Nous avons reçu ton feedback.',
  fb_success_body: 'Nous le passerons en revue sous 48h.',
  fb_send_another: 'Envoyer un autre',
  fb_disclaimer: "Ton feedback est lié à ton compte pour que nous puissions y revenir. Jamais partagé avec des tiers.",
  sa_send_to_coach: 'Envoyer au coach par email',
  sa_sending: 'Envoi...',
  sa_send_ok: 'Rapport envoyé à {email}',
  sa_send_fail: "Impossible d'envoyer l'email",
  sa_send_wait_save: "Attends que la tentative soit enregistrée (quelques secondes).",
  sa_inbox_title: 'Analyses reçues',
  sa_inbox_errors: 'erreurs',
  sa_voice_reply: 'Répondre en vocal',
  sa_voice_listen: 'Écouter',
  sa_voice_played: 'Lire',
  sa_voice_from_coach: 'Note du coach',
  sa_voice_play_fail: "Impossible de lire l'audio",
  sa_voice_modal_eyebrow: 'Note vocale',
  sa_voice_modal_title: 'Enregistrer une réponse',
  sa_voice_for: 'Pour',
  sa_voice_record: 'Enregistrer',
  sa_voice_pause: 'Pause',
  sa_voice_resume: 'Reprendre',
  sa_voice_stop: 'Stop',
  sa_voice_discard: 'Annuler',
  sa_voice_send: 'Envoyer au joueur',
  sa_voice_sending: 'Envoi...',
  sa_voice_sent: 'Note vocale envoyée au joueur',
  sa_voice_send_fail: "Impossible d'envoyer la note",
  sa_voice_mic_denied: 'Accès micro refusé. Active-le dans le navigateur.',
  sa_voice_remaining: '{n}s restantes · max 60s',
  sa_voice_max: 'Max {n}s',
  close: 'Fermer',
  iqs_label_placeholder: 'Étiquette (optionnel) : ex. "vs JV vendredi 21/2"',
  iqs_save_game: 'Enregistrer la partie',
  iqs_save_snapshot: "Enregistrer l'état",
  iqs_saving: 'Enregistrement…',
  iqs_save_ok: 'Partie enregistrée',
  iqs_save_fail: "Impossible d'enregistrer la partie",
  iqs_save_empty: 'Enregistre au moins une action avant de sauvegarder',
  iqs_stats_title: 'Statistiques de la partie',
  iqs_breakdown: 'Répartition',
  iqs_history: 'Historique récent',
  /* Manual */
  manual_h1: "Manuel d'Instruction",
  manual_subtitle: "Guide complet de toutes les fonctionnalités de PlayMaster IA. Mis à jour automatiquement à chaque nouvelle version.",
  manual_version: 'Version',
  manual_search_placeholder: 'Rechercher une fonction…',
  /* Marketplace */
  marketplace_back: 'Retour au Marketplace',
  marketplace_elite_coach: 'Coach Élite',
  marketplace_about_play: 'À propos de cette action',
  marketplace_purchase_success: 'Achat réussi ! Action ajoutée à votre playbook',
  marketplace_purchase_error: "Erreur lors de l'achat",
  marketplace_listing_not_found: 'Annonce introuvable.',
  marketplace_purchased: 'Acheté',
  marketplace_buy_cta: 'Acheter et ajouter à mon playbook',
  marketplace_coaches_own: 'coachs possèdent déjà cette action.',
  /* Roster */
  roster_invite_ready: 'Invitation prête — appuyez sur Partager',
  manual_no_results: 'Aucune section trouvée pour "{q}".',
  /* IQ Simulator landing (public) */
  iq_info_eyebrow: 'Nouveau · Fonction Premium Annuel',
  iq_info_h1_a: 'Entraînez votre QI', iq_info_h1_b: 'de basketball comme un pro',
  iq_info_subtitle: 'Le premier Simulateur de QI Basketball avec IA — entraînez les décisions réelles de match, pas des exercices isolés.',
  iq_info_para: "Game IQ Simulator présente des scénarios réels — couvertures de pick-and-roll, dernières possessions, défense en transition. Choisissez la décision la plus intelligente, recevez un feedback IA instantané, et regardez votre QI grandir. Conçu pour le basketball jeunesse, lycée, AAU, académies et niveau pro.",
  iq_info_cta_primary: 'Entraînez votre QI', iq_info_cta_pricing: 'Voir les plans',
  iq_info_video_coming: 'Vidéo démo en direct bientôt disponible', iq_info_try_live: 'Essayez en direct — inscription gratuite',
  iq_info_video_fallback: 'Votre navigateur ne supporte pas la vidéo. Inscrivez-vous pour essayer le simulateur.',
  iq_info_pillars_eyebrow: 'Pourquoi le Game IQ compte',
  iq_info_pillars_h2: 'Arrêtez les drills. Décidez.',
  iq_info_pillars_desc: "Les joueurs d'élite sont faits de décisions. PlayMaster IA apporte la répétition de décisions — celle que les rapports de scouting appellent \"basketball IQ\" — dans un format structuré et répétable.",
  iq_info_p1_t: 'Scénarios de jeu réels', iq_info_p1_d: "Pick-and-roll vs Drop / Hedge / Switch · Attaque de zone · Dernière possession · Transition · Défense contre ISO star — situations que tout joueur compétitif rencontre avant les U14.",
  iq_info_p2_t: 'Coaching IA instantané', iq_info_p2_d: 'Chaque décision est évaluée par Claude IA — vous recevez un feedback spécifique dans votre langue, pas des compliments génériques. Lisez l\'explication, corrigez l\'erreur.',
  iq_info_p3_t: 'Suivez votre Score IQ', iq_info_p3_d: 'Construisez un score mesurable par catégorie. Grimpez du rang Walk-on à Floor General. Les coachs voient les progrès des joueurs dans leur dashboard.',
  iq_info_how_eyebrow: 'Comment ça marche', iq_info_how_h2: '3 étapes vers un joueur plus intelligent',
  iq_info_s1_t: 'Choisissez un scénario', iq_info_s1_d: 'Offensif, Défensif — bientôt Mode Complet avec score, chrono et fautes.',
  iq_info_s2_t: 'Décidez en secondes', iq_info_s2_d: 'Lisez le terrain, choisissez la meilleure option parmi 3. Le temps de réaction compte.',
  iq_info_s3_t: 'Recevez le feedback IA', iq_info_s3_d: 'Claude IA explique pourquoi votre lecture a fonctionné — ou quelle était la décision optimale.',
  iq_info_who_eyebrow: 'Conçu pour', iq_info_who_h2: 'Coachs, joueurs et académies qui prennent le QI au sérieux',
  iq_info_who_list: 'Coachs de basketball jeunesse|Programmes lycée|Clubs AAU|Académies de basketball|Développement de joueurs pro & semi-pro|Joueurs individuels dès 12 ans',
  iq_info_inside_title: 'Inclus dans le plan Premium Annuel',
  iq_info_inside_desc: 'Game IQ Simulator est inclus dans le plan Premium Annuel — avec le playbook complet, AI Coach, gestion multi-équipe, mode académie et support prioritaire.',
  iq_info_final_h2: 'Faites que votre prochaine décision de basketball soit la bonne',
  iq_info_final_para: 'Rejoignez les coachs et joueurs qui entraînent déjà leur basketball IQ avec PlayMaster IA.',
  back_home: "Retour à l'accueil", signup: "S'inscrire",
  /* Misc */
  processing: 'Traitement...',

  // ── Public-facing surfaces (Plays Hub, Coach Profiles) — i18n batch 2026-02-25 ─────
  ph_counter_label: 'PLAYBOOK',
  ph_counter_word: 'JEUX',
  ph_tagline: 'Bibliothèque publique de jeux de basketball · diagrammes, variantes et contexte tactique. Un nouveau chaque jour.',
  ph_training_pill_prefix: 'Entraînement avec',
  ph_training_pill_suffix: 'tirs de vrais coachs',
  ph_filter_all: 'Tous',
  ph_sort_label: 'Trier :',
  ph_sort_recent: 'Récents',
  ph_sort_popular: 'Populaires',
  ph_sort_trending: 'Tendance',
  ph_nav_blog: 'Blog',
  ph_nav_login: 'Connexion',
  ph_nav_signup: "S'inscrire",
  ph_nav_jugadas: 'Jeux',
  ph_nav_coaches: 'Coachs',

  // Coach profile + directory
  cp_label_coach: 'COACH',
  cp_label_directory: 'ANNUAIRE',
  cp_loading: 'Chargement...',
  cp_404_title: 'Coach introuvable',
  cp_404_body: "Ce profil n'existe pas ou n'est pas public.",
  cp_back_to_plays: 'Retour aux jeux',
  cp_his_plays: 'Ses jeux',
  cp_no_plays_yet: "N'a pas encore publié de jeux.",
  cp_stat_plays: 'Jeux',
  cp_stat_likes: 'Likes',
  cp_stat_views: 'Vues',
  cp_stat_verified: 'Vérifié',
  cp_dir_coaches_label: 'Coachs',
  cp_dir_tagline: 'Communauté publique de coachs partageant leurs meilleurs jeux. Découvrez de vraies philosophies tactiques.',
  cp_dir_loading: 'Chargement des coachs...',
  cp_dir_empty: 'Vous êtes coach ? Activez votre profil public depuis votre compte pour apparaître ici.',
  cp_seo_default_desc: '{name} partage {count} jeux de basketball sur PlayMaster IA.',
  cp_seo_dir_desc: 'Annuaire public des coachs de basketball sur PlayMaster IA. Découvrez les coachs, leurs jeux et leur philosophie tactique.',

  // Public profile editor (inside /profile)
  ppe_title: 'Profil public',
  ppe_subtitle: 'Activez votre page publique. Indexable par Google. Idéale pour portfolio et recevoir des invitations.',
  ppe_public: 'PUBLIC',
  ppe_private: 'PRIVÉ',
  ppe_your_url: 'Votre URL :',
  ppe_copy: 'copier',
  ppe_open: 'ouvrir',
  ppe_copied: 'Copié',
  ppe_slug: 'Slug',
  ppe_country: 'Pays',
  ppe_country_placeholder: 'France',
  ppe_bio: 'Bio (max 600)',
  ppe_bio_placeholder: 'Parlez à la communauté de votre philosophie tactique.',
  ppe_twitter: 'Twitter (sans @)',
  ppe_instagram: 'Instagram (sans @)',
  ppe_website: 'Site web',
  ppe_website_placeholder: 'https://votre-academie.com',
  ppe_save: 'Enregistrer',
  ppe_saving: 'Enregistrement...',
  ppe_save_success: 'Profil mis à jour',
  ppe_save_error: "Impossible d'enregistrer",
  ph_empty_state: "Aucun jeu publié dans cette catégorie pour l'instant. Revenez demain.",
  ph_loading_more: 'Chargement...',
  ph_load_more: 'Charger plus',
  ph_footer_privacy: 'Confidentialité',
  ph_footer_terms: 'Conditions',
  landing_f_iqsim_t: 'Game IQ Simulator',
  landing_f_iqsim_d: 'Testez la lecture tactique de vos joueurs avec des scénarios réels générés par IA. Notation instantanée, explication du coach et progression mesurable.',
  landing_f_iqscore_t: 'IQ Score',
  landing_f_iqscore_d: "Note officielle d'IQ basket par joueur. Classement de l'équipe, évolution historique et comparaisons entre rosters.",
  landing_f_shot_t: 'Shot Analyzer',
  landing_f_shot_d: 'Analyse de la mécanique de tir par vision par ordinateur. Détection du cercle, trajectoire du ballon, biomécanique et heat maps par joueur.',
  nav_group_dashboard: 'Dashboard',
  nav_group_roster: 'Roster',
  nav_group_ai: 'AI Coach',
  nav_group_marketplace: 'Marketplace',
  nav_group_profile: 'Mon Profil',
  nav_board: 'Tableau',
  // ── Editor Easy mode (visible UI strings) — i18n batch 2026-02-25 ───
  ee_action_pass: 'Passe',
  ee_action_dribble: 'Dribble',
  ee_action_move: 'Déplacement',
  ee_action_cut: 'Coupe',
  ee_action_screen: 'Écran',
  ee_action_block: 'Bloc',
  ee_action_handoff: 'Handoff',
  ee_action_shot: 'Tir',
  ee_toast_defense_on: 'Mode défensif',
  ee_toast_offense_on: 'Mode offensif',
  ee_toast_full_court: 'Terrain complet',
  ee_toast_half_court: 'Demi-terrain',
  ee_toast_clean: 'Terrain effacé',
  ee_toast_no_teammates: 'Pas de coéquipiers',
  ee_toast_no_blockers: 'Pas de coéquipiers à bloquer pour',
  ee_toast_add_defense_first: "Ajoutez d'abord la défense",
  ee_toast_add_offense_first: "Ajoutez d'abord l'attaque",
  ee_toast_move_outside_arc: "Déplacez-vous hors de l'arc d'abord",
  ee_toast_save_failed: 'Impossible de sauvegarder',
  ee_play_defensive: 'Jeu défensif',
  ee_tooltip_fullscreen: 'Plein écran',
  ee_tooltip_exit_fullscreen: 'Quitter le plein écran',
  ee_tooltip_category_default: 'Catégorie par défaut (modifiez le nom pour classer)',
  ee_tooltip_category_detected: 'Catégorie détectée du nom',
  ee_btn_remove_defense: 'Retirer la défense',
  ee_btn_remove_offense: "Retirer l'attaque",
  ee_court_half: 'Demi',
  ee_court_full: 'Complet',
  ee_team_offense: 'Attaque',
  ee_team_defense: 'Défense',
  ee_tooltip_advanced_mode: 'Mode avancé avec tous les outils',
  ee_tooltip_exit_editor: "Quitter l'éditeur",
  ee_tooltip_edit_name: 'Modifier le nom du jeu',
  ee_draw_instruction: 'Faites glisser un joueur pour dessiner son mouvement',
  ee_btn_add_defense: 'Ajouter la défense',
  ee_btn_add_offense: "Ajouter l'attaque",
  ee_btn_clear: 'Effacer',
  ee_btn_save: 'Enregistrer',
  ee_btn_saved: 'Enregistré',
  ee_tooltip_drag_first: "Faites d'abord glisser un joueur",
  ee_tooltip_save_play: 'Enregistrer le jeu',
  ee_toast_saved_offline: 'Enregistré (hors ligne)',
  ee_default_play_name: 'Jeu',
  ee_label_attack: 'ATTAQUE',
  ee_label_defense: 'DÉFENSE',
  ph_cta_title: 'Débloquez la bibliothèque complète de jeux',
  ph_cta_subtitle: "Vous voyez seulement un aperçu. Inscrivez-vous gratuitement pour accéder au diagramme étape par étape, aux variantes et à la logique tactique de chaque jeu.",
  ph_cta_button: 'Créer un compte gratuit',
};

export default dict;
